import { render, staticRenderFns } from "./StaysSection.vue?vue&type=template&id=5ffd5dcb"
import script from "./StaysSection.vue?vue&type=script&lang=js"
export * from "./StaysSection.vue?vue&type=script&lang=js"
import style0 from "./StaysSection.vue?vue&type=style&index=0&id=5ffd5dcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports